<template>
  <div>
    <div class="bg-white rounded-md">
      <div
        class="border-b-0.5 flex flex-wrap lg:gap-0 gap-4 justify-between items-center py-3"
      >
        <div class="flex gap-4">
          <input
            type="text"
            placeholder="Search Competency"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
          <input
            type="text"
            onfocus="(this.type='date')"
            onbur="(this.type='text')"
            placeholder="Due Date"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
        </div>
      </div>
      <div class="">
        <ve-table :columns="columns" :table-data="tableData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Report",
  components: {},
  data() {
    return {
      showAddRecommendation: false,
      columns: [
        {
          field: "Year",
          key: "a",
          title: "Year",
          align: "center",
        },

        {
          field: "ReviewPeriod",
          key: "c",
          title: "Review Period",
          align: "left",
        },

        {
          field: "File",
          key: "file",
          title: "File",

          renderBodyCell: () => (
            <img
              class="h-8 w-8 mx-auto cursor-pointer"
              src={this.getIcon()}
              onClick={this.handleReportClick}
            />
          ),
        },
      ],
      tableData: [
        {
          Year: "2022",
          ReviewPeriod: "January-July",
          File: "",
        },
      ],
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
    };
  },
  methods: {
    getIcon() {
      return require("@/assets/icons/pdf.png");
    },
    handleReportClick() {},
  },
};
</script>
